// src/components/VeiculoCard.js

import React from 'react';
import './VeiculoCard.css'; 
import { FaEdit, FaTrash, FaIdCard, FaCheckSquare, FaRegSquare, FaWrench, FaChartLine } from 'react-icons/fa';

const formatCurrency = (value) => {
    const num = parseFloat(value);
    if (isNaN(num)) return 'R$ 0,00';
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(num);
};

export default function VeiculoCard({ veiculo, isSelected, onToggleSelect, hasAdminPermission, onViewDetails, onEdit, onDelete }) {
    
    // Tratamento de status para gerar a classe de cor correta
    const statusClass = veiculo.status?.toLowerCase()
        .replace(/ /g, '-')
        .replace('ç', 'c')
        .replace('í', 'i')
        .replace('ã', 'a') || 'disponivel';

    return (
        <article className={`vec-card ${isSelected ? 'selected' : ''}`}>
            <header className="vec-card-header">
                <div className="vec-card-title-group">
                    {hasAdminPermission && (
                        <div className="vec-card-checkbox" onClick={onToggleSelect}>
                            {isSelected ? <FaCheckSquare className="checked" /> : <FaRegSquare />}
                        </div>
                    )}
                    <div className="vec-avatar">
                        {veiculo.marca ? veiculo.marca.charAt(0).toUpperCase() : 'V'}
                    </div>
                    <div className="vec-card-title-texts">
                        <h3 title={`${veiculo.marca} ${veiculo.modelo}`}>{veiculo.marca} {veiculo.modelo}</h3>
                        <span className="vec-ano-text">Ano: {veiculo.ano || 'N/D'}</span>
                    </div>
                </div>
                
                <div className="vec-card-actions">
                    {hasAdminPermission && (
                        <>
                            <button onClick={onEdit} className="vec-icon-btn edit" title="Editar / Lançar Despesa"><FaEdit /></button>
                            <button onClick={onDelete} className="vec-icon-btn delete" title="Excluir Veículo"><FaTrash /></button>
                        </>
                    )}
                </div>
            </header>

            <div className="vec-card-body">
                {/* Placa e Status lado a lado */}
                <div className="vec-placa-row">
                    <div className="vec-placa-box">
                        <FaIdCard className="vec-info-icon" />
                        <span className="vec-placa-highlight" title="Placa do Veículo">{veiculo.placa}</span>
                    </div>
                    <span className={`vec-status-badge status-${statusClass}`}>{veiculo.status}</span>
                </div>
            </div>

            <footer className="vec-card-footer">
                <div className="vec-footer-metrics">
                    <div className="vec-metric-item">
                        <span className="vec-metric-label"><FaWrench /> Manutenções</span>
                        <strong className="vec-metric-value text-red">{formatCurrency(veiculo.custo_total_manutencoes)}</strong>
                    </div>
                </div>
                
                <button className="vec-btn-analytics" onClick={onViewDetails}>
                    <FaChartLine /> Painel de Analytics
                </button>
            </footer>
        </article>
    );
}